import { ReactElement, useState } from "react";
import { IHostSystemInformation } from "./types";
import FileSystemComponent from "./fileSystemComponent";
import ContainersComponent from "./containersComponent";
import SystemComponent from "./systemComponent";
import { Accordion, AccordionDetails, AccordionSummary, Chip } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DateTime } from "luxon";

interface IProps {
  status: IHostSystemInformation;
}

const thirtyMinutes = 1800;
const fifteenMinutes = 900;

const HostStatus = ({ status }: IProps): ReactElement => {
  const [ expanded, setExpanded ] = useState(true);

  let colorDate: "error" | "success" | "warning" = "success";

  const deltaDatetime = DateTime.now().toSeconds() - DateTime.fromISO(status.datetime, { zone: "America/Chicago" }).toSeconds();

  if (deltaDatetime > thirtyMinutes) {
    colorDate = "error";
  } else if (deltaDatetime > fifteenMinutes) {
    colorDate = "warning";
  }

  return (
    <Accordion className="mb-1" expanded={expanded} onChange={() => setExpanded(!expanded)}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <div className="display-flex-row w-100" >
          <strong className="flex-grow-1">
            {`${status.code} - [ ${status.osInfo.hostname} / ${status.osInfo.platform} / ${status.osInfo.distro} ]`}
          </strong>
          <Chip color={colorDate} label={`LAST UPDATE: ${status.datetime}`} size="small" />
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <div className="display-flex-column p-1  align-items-start">
          <SystemComponent status={status}/>
          <FileSystemComponent status={status}/>
          <ContainersComponent status={status}/>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default HostStatus;